const ChainedMap = require('./ChainedMap');

module.exports = class extends ChainedMap {
  constructor(parent) {
    super(parent);
    this.extend([
      'asyncChunks',
      'auxiliaryComment',
      'charset',
      'chunkFilename',
      'chunkLoadTimeout',
      'chunkLoadingGlobal',
      'chunkLoading',
      'chunkFormat',
      'enabledChunkLoadingTypes',
      'crossOriginLoading',
      'devtoolFallbackModuleFilenameTemplate',
      'devtoolModuleFilenameTemplate',
      'devtoolNamespace',
      'filename',
      'assetModuleFilename',
      'globalObject',
      'uniqueName',
      'hashDigest',
      'hashDigestLength',
      'hashFunction',
      'hashSalt',
      'hotUpdateChunkFilename',
      'hotUpdateGlobal',
      'hotUpdateMainFilename',
      'library',
      'libraryExport',
      'libraryTarget',
      'importFunctionName',
      'path',
      'pathinfo',
      'publicPath',
      'scriptType',
      'sourceMapFilename',
      'sourcePrefix',
      'strictModuleErrorHandling',
      'strictModuleExceptionHandling',
      'umdNamedDefine',
      'workerChunkLoading',
      'enabledLibraryTypes',
      'environment',
      'compareBeforeEmit',
      'wasmLoading',
      'enabledWasmLoadingTypes',
      'iife',
      'module',
      'clean',
    ]);
  }
};
